<template>
  <div class="data-grid-search-form"
       v-if="searchColumns && searchColumns.length > 0">
    <keep-alive>
      <DataGridSearchCondition v-if="useSearchKeyMode && advanceSearchConditions && advanceSearchConditions.length"
                               :search-conditions="advanceSearchConditions"
                               :search-expend="config.search.advanced"
                               @del-key-item="handleDelKeyItem"
                               @del-key="handleDelKey">
        <template #append>
          <el-button size="mini" type="default" plain @click="inputSearchKey">修改搜索条件</el-button>
          <el-button size="mini" type="default" plain @click="resetSearchKey">清除搜索条件</el-button>
        </template>
      </DataGridSearchCondition>
      <DataGridSearchFormInput v-else
                               :config="config"
                               :grid="grid"
                               :search-columns="searchColumns"
                               :search-expend="config.search.advanced"
                               :max-row-line="4"
                               v-bind="$attrs"
                               @search="handleFormSearch">
        <template #append="{reset}">
          <el-button size="mini" type="primary" @click="handleFormSearch">立即搜索</el-button>
          <el-button size="mini" type="default" @click="reset">重置条件</el-button>
        </template>
      </DataGridSearchFormInput>
    </keep-alive>
  </div>
</template>

<script>
import DataGridSearchCondition from './DataGridSearchCondition'
import DataGridSearchFormInput from './DataGridSearchFormInput'
import objectUtils from '../../../util/objectUtils'
import layoutConstants from '../../../constants/layoutConstants'
import conditionEnum from '../../../constants/conditionEnum'
export default {
  name: 'DataGridSearchForm',
  components: {
    DataGridSearchCondition,
    DataGridSearchFormInput
  },
  props: {
    config: {
      required: true,
      type: Object
    },
    grid: {
      required: true,
      type: Object
    },
    searchColumns: {
      type: Array
    }
  },
  data () {
    return {
      showSearchKey: false
    }
  },
  computed: {
    useSearchKeyMode () {
      return layoutConstants.template.grid.search.keyMode && this.showSearchKey
    },
    advanceSearchConditions () {
      let currentParams = this.grid.search.currentParams
      if (currentParams) {
        let matchMap = currentParams.matchMap
        if (matchMap) {
          let columns = this.grid.data.config ? this.grid.data.config.columns : null
          if (columns) {
            let conditions = []
            Object.keys(matchMap).forEach(itemKey => {
              let keys = itemKey.split(':')
              let column = columns.find(col => col.prop === keys[0])
              if (column) {
                let match = matchMap[itemKey]
                let condition
                if (keys.length > 1) {
                  condition = Object.values(conditionEnum).find(c => c.name === keys[1])
                }
                if (objectUtils.hasValue(match) || (condition && !condition.data)) {
                  if (Array.isArray(match) && match.length) {
                    let inputConfig = column.inputConfig
                    if (inputConfig && ['DATE_FIELD', 'DATETIME_FIELD', 'CUSTOM_DATE_FIELD'].includes(inputConfig.elementType) && match.length === 2) {
                      conditions.push({
                        key: column._prop,
                        label: column.name,
                        value: match.join(' ~ '),
                        condition: condition
                      })
                    } else {
                      conditions.push({
                        key: column._prop,
                        label: column.name,
                        value: match,
                        condition: condition,
                        group: true
                      })
                    }
                  } else {
                    conditions.push({
                      key: column._prop,
                      label: column.name,
                      value: match,
                      condition: condition
                    })
                  }
                }
              }
            })
            return conditions
          }
        }
      }
    }
  },
  methods: {
    handleDelKeyItem (searchCondition, index) {
      let matchMap = this.grid.search.matchMap
      if (matchMap) {
        let getVal = matchMap[searchCondition.key]
        if (getVal) {
          let items = getVal.value
          if (Array.isArray(items) && index < items.length) {
            if (items.length > 1) {
              items.splice(index, 1)
            } else {
              this.$set(getVal, 'value', '')
            }
            this.$nextTick(() => this.handleFormSearch())
          }
        }
      }
    },
    handleDelKey (searchCondition) {
      let matchMap = this.grid.search.matchMap
      if (matchMap) {
        let getVal = matchMap[searchCondition.key]
        if (getVal) {
          this.$set(getVal, 'value', '')
          this.$set(getVal, 'condition', '')
          this.$nextTick(() => this.handleFormSearch())
        }
      }
    },
    inputSearchKey () {
      this.showSearchKey = false
    },
    resetSearchKey () {
      let advanceSearchConditions = this.advanceSearchConditions
      if (advanceSearchConditions) {
        let matchMap = this.grid.search.matchMap
        if (matchMap) {
          advanceSearchConditions.forEach(searchCondition => {
            let getVal = matchMap[searchCondition.key]
            if (getVal) {
              this.$set(getVal, 'value', '')
              this.$set(getVal, 'condition', '')
            }
          })
          this.$nextTick(() => this.handleFormSearch())
        }
      }
    },
    handleFormSearch () {
      this.$emit('handleFormSearch')
    }
  },
  watch: {
    'grid.search.currentParams.matchMap': {
      handler: function (val) {
        if (val) {
          this.showSearchKey = Object.keys(val).some(key => {
            let getVal = val[key]
            if (Array.isArray(getVal) ? getVal.length > 0 : objectUtils.hasValue(getVal)) {
              return true
            }
            let keys = key.split(':')
            if (keys.length > 1) {
              let condition = Object.values(conditionEnum).find(c => c.name === keys[1])
              if (condition && !condition.data) {
                return true
              }
            }
          })
        } else {
          this.showSearchKey = false
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
  .data-grid-search-form {
    background-color: #fff;
  }
</style>
